import { BusyButton, BusyButtonLink } from '@ztechapps/webui.button'
import { Dropdown } from 'react-bootstrap'
import { IconValueBlock } from '@ztechapps/webui.util'
import type { FunctionComponent } from 'react'
import React from 'react'

export type RowActionMenuProps = {
  icon: string
  label: string
  className?: string
  isBusy?: boolean
  disabled?: boolean
  text?: string
  onClick: React.MouseEventHandler<HTMLElement>
}

export type RowActionMenuType = 'button' | 'menu'

export const RowActionMenu = (
  props: RowActionMenuProps & { type?: RowActionMenuType; as?: FunctionComponent<RowActionMenuProps> }
) => {
  const { type, as, ...rest } = props
  if (as) {
    const As = as
    return <As {...rest} />
  }

  if (type === 'menu') {
    return <RowActionMenuItem {...rest} />
  } else {
    return <RowActionMenuButtonLink {...rest} />
  }
}

export const RowActionMenuButtonLink = ({
  onClick,
  icon,
  label,
  className,
  disabled,
  text,
  isBusy,
}: RowActionMenuProps) => {
  return (
    <BusyButtonLink
      bsSize="lg"
      onClick={onClick}
      icon={icon}
      title={label}
      text={text}
      variant={className ? undefined : 'outline-primary'}
      className={className}
      disabled={disabled}
      isBusy={isBusy}
      busyText=" "
    />
  )
}

export const RowActionMenuButton = ({
  onClick,
  icon,
  label,
  className,
  disabled,
  text,
  isBusy,
}: RowActionMenuProps) => {
  return (
    <BusyButton
      onClick={onClick}
      icon={icon}
      title={label}
      text={text}
      variant={className ? undefined : 'outline-primary'}
      className={className}
      disabled={disabled}
      isBusy={isBusy}
      busyText=" "
    />
  )
}

export const RowActionMenuItem = ({ onClick, icon, label, className, disabled, text }: RowActionMenuProps) => {
  const labelOrText = label || text
  return (
    <Dropdown.Item eventKey={labelOrText} onClick={onClick} disabled={disabled}>
      <IconValueBlock icon={icon} value={labelOrText} className={className} />
    </Dropdown.Item>
  )
}
